import axios, { isAxiosError } from 'axios'

import { useUser } from '@/store/user'
import { useAuth } from '@/store/auth'

// On a retryable 401, refresh tokens once and repeat the original request.
export async function retryOnUnauthorized(error) {
  const shouldRetry =
    isAxiosError(error) &&
    error.response?.status === 401 &&
    error.config?.retryable

  if (!shouldRetry) {
    return Promise.reject(error)
  }

  const auth = useAuth()
  const user = useUser()

  await auth.refresh()

  if (user.authorized && !error.config.skipAuth) {
    error.config.headers = error.config.headers ?? {}
    error.config.headers['Authorization'] = `Bearer ${auth.accessToken}`

    return axios(error.config)
  }

  return Promise.reject(error)
}
